import PrevButton from "components/PrevButton";
import NextButton from "components/NextButton";
import SelectInput from "components/SelectInput";
import { yearsOptions } from "constants/index";
import { adequacySkipLinkText } from "i18n/messages/buttonTitles";
import { useSideModalScrollToTop } from "hooks";

const Bonds = ({
    isBondsVaild,
    setActiveStep,
    formatMessage,
    messages,
    formData,
    setFormData,
    setAdequacyStart,
    adequacyData,
    backSlideEffect = "",
    setBackSlideEffect,
    open,
    StatusAdequacy,
}) => {
    useSideModalScrollToTop();

    return (
        <>
            <div className={`bonds multisteps ${backSlideEffect}`}>
                <div className="header-part">
                    <h4 className="primary-color">{formatMessage(messages.secondHeading)}</h4>
                </div>
                <div className="content">
                    <form method="post" className="survey-form">
                        <div className="first-question">
                            <h3 className="mt-4 mb-7">{formatMessage(messages.secondQuestion)}</h3>
                            <div className="tabs">
                                <div>
                                    <input
                                        id="bondsYes"
                                        type="radio"
                                        name="bonds-experience"
                                        onChange={() =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                bonds: { ...prevState.bonds, IsBondsXPConfirmed: true },
                                            }))
                                        }
                                        checked={formData?.bonds?.IsBondsXPConfirmed === true}
                                    />
                                    <label
                                        className="medium mw-100"
                                        htmlFor="bondsYes"
                                        onClick={(e) =>
                                            jQuery(e.target).closest(".survey-form").find(".second-question").slideDown()
                                        }
                                    >
                                        {formatMessage(messages.yesText)}
                                    </label>
                                </div>

                                <div>
                                    <input
                                        id="bondsNo"
                                        type="radio"
                                        name="bonds-experience"
                                        onChange={() =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                bonds: {
                                                    ...prevState.bonds,
                                                    IsBondsXPConfirmed: false,
                                                    IsBondsXPConfirmedDate: "",
                                                },
                                            }))
                                        }
                                        checked={formData?.bonds?.IsBondsXPConfirmed === false}
                                    />
                                    <label
                                        className="medium mw-100"
                                        htmlFor="bondsNo"
                                        onClick={(e) =>
                                            jQuery(e.target).closest(".survey-form").find(".second-question").slideUp()
                                        }
                                    >
                                        {formatMessage(messages.noText)}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div
                            className="second-question"
                            style={{ display: formData?.bonds?.IsBondsXPConfirmed ? "block" : "none" }}
                        >
                            <div className="border-x" />
                            <h4>{formatMessage(messages.secondQuestionOther)}</h4>
                            <div className="">
                                <SelectInput
                                    maxMenuHeight={400}
                                    isSearchable={false}
                                    menuPlacement="top"
                                    className="select form-item"
                                    classNamePrefix="select"
                                    name="bonds-experience-years"
                                    options={yearsOptions()}
                                    placeholder={formatMessage(messages.pleaseSelect)}
                                    value={formData?.bonds?.IsBondsXPConfirmedDate || ""}
                                    onChange={(selectedOption) => {
                                        setFormData((prevState) => ({
                                            ...prevState,
                                            bonds: { ...prevState.bonds, IsBondsXPConfirmedDate: selectedOption },
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </div>
                {StatusAdequacy != "renew" && (
                    <span
                        onClick={() => {
                            setAdequacyStart({ step: 2 });
                            setBackSlideEffect("step-slide-right");
                        }}
                        className="skip-link"
                    >
                        {formatMessage(adequacySkipLinkText)}
                    </span>
                )}
            </div>
            {open && (
                <div className="bottom-bar-container">
                    <PrevButton
                        onClick={() => {
                            setActiveStep(1);
                            setBackSlideEffect("step-slide-right");
                        }}
                    />
                    <NextButton
                        className={`${isBondsVaild ? "" : "disable-grey"}`}
                        onClick={() => {
                            if (isBondsVaild) {
                                setAdequacyStart({
                                    step: 6,
                                    survey_second_step: { ...adequacyData.survey_second_step, ...formData, step: 3 },
                                });
                                setActiveStep(3);
                                setBackSlideEffect("step-slide-left");
                            }
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default Bonds;
